import axios from "axios";
import moment from "moment";

export const customerSignup = (data) => {
  const graphqlQuery = {
    query: `
    mutation($signupModel : UserVMInput!){
        postUser(model: $signupModel) {
          error_code,
          message,
          success,
          result {
            id,
            name,
            phone_number,
            image,
            code,
            code_generated_on,
          }
        }
      }
    `,
    variables: data,
  };
  let response = null;
  return (response = axios({
    url: process.env.REACT_APP_BASEURL,
    method: "POST",
    data: graphqlQuery,
  }));
};

export const verifyCode = (data) => {
  const graphqlQuery = {
    query: `mutation($verifyCodeModel : VerifyCodeVMInput!){
      verifyCode(model: $verifyCodeModel ) {
        error_code,
        message,
        success,
        result {
          id,
          image,
          name,
          phone_number,
      
        }
      }
    }
    `,
    variables: data,
  };
  let response = null;
  return (response = axios({
    url: process.env.REACT_APP_BASEURL,
    method: "POST",
    data: graphqlQuery,
  }));
};

export const customerLogin = (data) => {
  const graphqlQuery = {
    query: `mutation($getCode : String!){
      generateVerificationCode(phone: $getCode) {
        error_code,
        message,
        success,
      }
      }
    `,
    variables: data,
  };
  let response = null;
  return (response = axios({
    url: process.env.REACT_APP_BASEURL,
    method: "POST",
    data: graphqlQuery,
  }));
};

export const editProfile = (data) => {
  return axios.post(
    process.env.REACT_APP_BASEURL_ONLY + "api/user/post",
    data,
    {
      "axios-retry": {
        retries: 5,
      },
    }
  );
};

export const getAllBranches = (page, limit, type, lat, lng) => {
  const graphqlQuery = {
    query: `query{
      getAllBranchs(limit:${limit},page: ${page},type: ${type},current_lat: ${lat},current_long: ${lng} ) {
        error_code,
        success,
        status,
        message,
        result {
          id,
          address,
          city,
          latitude,
          longitude,
          name,
          name_ar,
          mobile,
          slot_interval,
          opening_time,
          closing_time,
          off_days,
          created_on,
        }
      }
    }
    `,
  };
  let response = null;
  return (response = axios({
    url: process.env.REACT_APP_BASEURL,
    method: "POST",
    data: graphqlQuery,
  }));
};

export const getAllCategoriesByBrancheId = (page, limit, branchId) => {
  const graphqlQuery = {
    query: `query{
      getAllCategorys(branchId: ${branchId},limit:${limit},page: ${page}) {
        error_code,
        success,
        status,
        message,
        total_records,
        result {
          id,
          name,
          name_ar,
          image,
          description,
          description_ar, 
        }
      }
    }
    `,
  };
  let response = null;
  return (response = axios({
    url: process.env.REACT_APP_BASEURL,
    method: "POST",
    data: graphqlQuery,
  }));
};

export const getAllServicesByCategoryId = (
  page,
  limit,
  branchId,
  categoryId
) => {
  const graphqlQuery = {
    query: `query{
      getAllServices(branchId: ${branchId}, categoryId: ${categoryId} ,limit:${limit}, page: ${page} ) {
        error_code,
        success,
        status,
        message,
        total_records,
        result {
          id,
          name,
          name_ar,
          description,
          description_ar,
          image,
          category_id,
          branch_id,
          price,
          executive_price,
          time
        }
      }
    }
    `,
  };
  let response = null;
  return (response = axios({
    url: process.env.REACT_APP_BASEURL,
    method: "POST",
    data: graphqlQuery,
  }));
};

export const getAllAvailableEmployees = (data) => {
  console.log("data", data);
  const graphqlQuery = {
    query: `query($getAvailableEmployeesModel: FreeEmployeesVMInput!){
      getFreeEmployees(model: $getAvailableEmployeesModel){
      error_code,
      success,
      status,
      message,
      total_records,
      page,
      result {
        id,
        user_role,
        name,
        image,
        rating,
        employees{
          id,
          first_name,
          last_name,
          rating,
          description,
          description_ar,
          image,
          user_id
        }
      }
      }
    }`,
    variables: data,
  };
  let response = null;
  return (response = axios({
    url: process.env.REACT_APP_BASEURL,
    method: "POST",
    data: graphqlQuery,
  }));
};
// branchId: ${branchId}, serviceId: ${serviceId} ,limit:${limit}, page: ${page}
// export const getAllEmployees = (page, limit, branchId, serviceId, currentDate) => {
export const getAllEmployees = (
  page,
  limit,
  branchId,
  serviceId,
  currentDate
) => {
  const graphqlQuery = {
    // getAllEmployees(branchId: ${branchId}, serviceId: ${serviceId} ,limit:${limit}, page: ${page}, currentDate: ${currentDate != null ? currentDate : null})
    query: `query{
      getAllEmployees(branchId: ${branchId}, serviceId: ${serviceId} ,limit:${limit}, page: ${page}, currentDate: "${currentDate}") 
      {
        success,
        message,
        total_records,
        page,
        result {
          image,
          id,
          employees{
            id,
            first_name,
            last_name,
            rating,
            description,
            description_ar,
            image,
            user_id
          }
          
        }
      }
    }
    `,
  };
  let response = null;
  return (response = axios({
    url: process.env.REACT_APP_BASEURL,
    method: "POST",
    data: graphqlQuery,
  }));
};

export async function searchEmployeeApiCall(object) {
  console.log("object", object);
  const graphqlQuery = {
    query: `
  query($model: PhoneNumberOrNameVMInput!){
    getUserByPhoneNumberOrName(model: $model) {
      error_code,
      message,
      result {
        id,
        image,
        employees{
          id,
         age,
         rating,
         user_id,
         branch_id,
         description,
         description_ar,
         first_name,
         first_name_ar,
         last_name,
         last_name_ar,
         gender 
        },
        name,
        rating,
        
  
      }
    }
  }
`,
    variables: object,
  };
  let response = null;
  return (response = axios({
    url: process.env.REACT_APP_BASEURL,
    method: "POST",
    data: graphqlQuery,
  }));
}

export async function getEmployeeSchedule(object) {
  const graphqlQuery = {
    query: `
  query($model : EmployeeScheduleVMInput!){
    getEmployeeSchedule (model: $model){
      error_code,
      message,
      result {
        start,
        end,
        status
      }
    }
  }
`,
    variables: object,
  };
  let response = null;
  return (response = axios({
    url: process.env.REACT_APP_BASEURL,
    method: "POST",
    data: graphqlQuery,
  }));
}

export const getEmployeeRatings = (id) => {
  const graphqlQuery = {
    query: `
    query{
      getRatingReviews(id: ${id}) {
        error_code,
        message,
        total_records,
        success,
        result {
          cutomer_names,
          image,
         rating,
         review 
        }
      }
    }
  `,
  };
  let response = null;
  return (response = axios({
    url: process.env.REACT_APP_BASEURL,
    method: "POST",
    data: graphqlQuery,
  }));
};

export const getVatRateById = (id) => {
  const params = {};
  if (id) {
    params.id = id;
  }
  return axios.get(
    process.env.REACT_APP_BASEURL_ONLY + "api/organization/get",
    {
      params,
      headers: {
        "Content-Type": "application/json",
      },
      "axios-retry": {
        retries: 5,
      },
    }
  );
};

export const GetDiscountWithCouponApiCall = (branchId, coupon, dateTime) => {
  const graphqlQuery = {
    query: ` query{
      validateCoupon(branchId: ${branchId},coupon: "${coupon}", currentDateTime:"${dateTime}") {
        error_code,
        message,
        success,
        result {
          amount,
          type,
        }
      }
      }`,
  };
  let response = null;
  return (response = axios({
    url: process.env.REACT_APP_BASEURL,
    method: "POST",
    data: graphqlQuery,
  }));
};

export const addNewBooking = (bookingObj) => {
  const graphqlQuery = {
    query: `mutation($bookingModel : BookingVMInput!){
      postBooking(model: $bookingModel) {
        error_code,
        success,
        message,
      }
    }
    `,
    variables: bookingObj,
  };
  let response = null;
  return (response = axios({
    url: process.env.REACT_APP_BASEURL,
    method: "POST",
    data: graphqlQuery,
  }));
};

export const getAllUpComingAndPreviousBookings = (data) => {
  const graphqlQuery = {
    query: `
    query getBookingDetail($model: GetBookingDetailsVMInput!){
      getBookingDetails (model: $model) {
        error_code,
        message,
        success
        result {
          employee_name,
          employee_discription,
          employee_rating,
            id,
            customer_user_id,
            employee_user_id,
            service_id,
            price,
            is_executive,
            rating,
            start_datetime,
            end_datetime,
            status_id
           review,
           service_name,

          }
              
         } 
        
      }
  `,
    variables: data,
  };
  let response = null;
  return (response = axios({
    url: process.env.REACT_APP_BASEURL,
    method: "POST",
    data: graphqlQuery,
  }));
};

export const AddCustomerReviewsAndRatings = (data) => {
  return axios.post(
    process.env.REACT_APP_BASEURL_ONLY + "api/booking-detail/post-rate-review",
    data,
    {
      "axios-retry": {
        retries: 5,
      },
    }
  );
};

export const contactUs = (data) => {
  return axios.post(
    process.env.REACT_APP_BASEURL_ONLY + "api/contact-us/post",
    data,
    {
      "axios-retry": {
        retries: 5,
      },
    }
  );
};

export const getAllNotifications = (userId, readStatus, page, limit) => {
  const params = {};
  if (userId) {
    params.user_id = userId;
  }
  if (readStatus == 0 || readStatus) {
    params.read_status = readStatus;
  }
  if (page) {
    params.page = page;
  }
  if (limit) {
    params.limit = limit;
  }
  return axios.get(
    process.env.REACT_APP_BASEURL_ONLY +
      "api/notification/get-user-notifications-by-status",
    {
      params,
      headers: {
        "Content-Type": "application/json",
      },
      "axios-retry": {
        retries: 5,
      },
    }
  );
};

export const notificationStatusChange = (data) => {
  return axios.post(
    process.env.REACT_APP_BASEURL_ONLY +
      "api/notification/change-notificaiton-status",
    data,
    {
      "axios-retry": {
        retries: 5,
      },
    }
  );
};

export const getContactUsContent = () => {
  const graphqlQuery = {
    query: `query{
      getOrganizationalSettingSiteContactUs() {
        error_code,
        success,
        status,
        message,
        result {
        contact_us_get_in_touch,
        contact_us_get_in_touch_ar,
        }
      }
    }
    `,
  };
  let response = null;
  return (response = axios({
    url: process.env.REACT_APP_BASEURL,
    method: "POST",
    data: graphqlQuery,
  }));
};

export const getAboutUsContent = () => {
  const graphqlQuery = {
    query: `query{
      getOrganizationalSettingSiteAboutUs() {
        error_code,
        success,
        status,
        message,
        result {
         about_us,
        about_us_ar,
        our_vision,
        our_vision_ar, 
        why_choose_us{
            title_ar,
            description_ar,
            title,
            description,
            icon,    
          },
           about_us_footer,
          about_us_footer_ar,
          phone_number,
          email,
          location,
          location_ar,
        
        }
      }
    }
    `,
  };
  let response = null;
  return (response = axios({
    url: process.env.REACT_APP_BASEURL,
    method: "POST",
    data: graphqlQuery,
  }));
};

export const getHomeContent = () => {
  const graphqlQuery = {
    query: `query{
      getOrganizationalSettingHomeContent() {
        error_code,
        success,
        status,
        message,
        result {
          title,
          title_ar,
          description,
          description_ar,
          sorting,
      }
    }
    }
    `,
  };
  let response = null;
  return (response = axios({
    url: process.env.REACT_APP_BASEURL,
    method: "POST",
    data: graphqlQuery,
  }));
};
